import { PaginationModel } from '@fh-client-interaction-frontends/fh-providers';
import { BackofficeUsersModel } from '../../dto/backoffice/backoffice-users/backoffice-users-model';
import { BackofficeUsersResponseInterface } from '../../../interfaces/response/backoffice-users/backoffice-users-response-interface';

export class BackofficeUsersResponseModel implements BackofficeUsersResponseInterface {
  userList: BackofficeUsersModel[] = new Array<BackofficeUsersModel>();
  pagination: PaginationModel = new PaginationModel();

  constructor(init?: Partial<BackofficeUsersResponseModel>) {
    Object.assign(this, init);
  }
}
